import React from "react";
import DownloadIcon from '@mui/icons-material/Download';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import IconButton from '@mui/material/IconButton';
import ImageIcon from '@mui/icons-material/Image';
import './index.css'

export default function ImageButton({
    data,
    label,
    type
}) {
    return type == 'document'
        ? (
            <a href={data?.data} download={label}>
                <IconButton size="xx-large"  >
                    <PictureAsPdfIcon color='action' />
                </IconButton>
                {label}
            </a>
        )
        : (
            <div >
                {/* <img className="img" src={data?.data} alt={label} /> */}
                <a href={data?.data} download={label}>
                    <IconButton className="dl-btn" size="xx-large"  >
                        <ImageIcon color='action' />
                    </IconButton>
                    {label}
                </a>
            </div>
        )


}
